import React from 'react';
import { Box } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../store';
import { logout } from '../../store/slices/authSlice';
import AppHeader from '../AppHeader';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.auth);

  const handleSignOut = async () => {
    try {
      await dispatch(logout()).unwrap();
    } catch (error) {
      console.error('Failed to sign out:', error);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: 'background.default'
      }}
    >
      {/* Signed out (the sign-in screen) gets the page to itself. */}
      {user && <AppHeader onSignOut={handleSignOut} />}
      <Box sx={{ flexGrow: 1 }}>{children}</Box>
    </Box>
  );
};

export default Layout;
